import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {StoryCard} from "../story-card";
import {DataService} from "../../../services/data.service";
import {Story} from "../../../interfaces/story";
import {StudentAuthService} from "../../../services/student-auth.service";
import {DotLottie} from "@lottiefiles/dotlottie-web";
import {QuestsHelperService} from "../../../services/quests-helper.service";

@Component({
  selector: 'brt-quizgame-card',
  templateUrl: './quizgame-card.component.html',
  styleUrls: ['./quizgame-card.component.scss']
})
export class QuizgameCardComponent implements OnInit, OnDestroy {

  questionDuration = 45000;
  timeLeft = this.questionDuration;
  timePercentage = 100;
  timeRunning = false;
  timeLow = false;
  questionAnsweredLocalState = false;
  timerInterval?: any;
  selectedAnswerId = "";
  correctAnswerId = "";
  result = "";

  @Input('story-data') set setStoryData(val: Story) {
    this.storyData = val;
  };

  @Input('card-data') set setCardData(val: StoryCard) {
    this.cardData = val;
  };

  @Input('current') set setCurrent(val: boolean) {
    this.current = val;
  }

  @Output('timed-out') timedOut = new EventEmitter<boolean>();

  current: boolean = false;
  cardData!: StoryCard;
  storyData!: Story;

  gameId = 0;
  questionId = 0;
  questionText = "";
  answers: {
    id: string,
    text: string
  }[] = new Array(0);
  round = 1;

  gameEnded = false;

  animInterval = -1;

  constructor(
    private data: DataService,
    private studentAuthService: StudentAuthService,
    private questsHelperService: QuestsHelperService
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    window.clearInterval(this.animInterval);
  }

  startGame() {
    this.round = 1;
    this.data.getGameStoryQuiz(this.studentAuthService.getClientId(), this.storyData.id).subscribe(response => {
      this.gameEnded = false;
      this.gameId = parseInt(response.id);
      this.getQuestion();
    });
  }

  getQuestion() {
    this.resetTimer();
    if(this.gameId) {
      this.data.getStoryQuizQuestion(parseInt(this.gameId.toString()), this.round).subscribe(response => {
        this.questionId = parseInt(response.id);
        this.questionText = response.text ?? "";
        this.answers = (response.answers ?? []).map(answer => ({id: answer.id, text: answer.text ?? ""}));
        this.selectedAnswerId = "";
        this.correctAnswerId = "";

        setTimeout(() => {
          this.startTimer();
        }, 1000);

      });
    }
  }

  answerQuestion(answerId: string) {

    if(this.questionAnsweredLocalState) {
      return;
    }

    this.questionAnsweredLocalState = true;

    this.selectedAnswerId = answerId;
    this.stopTimer();

    setTimeout(() => {

      this.data.setStoryQuizQuestionAnswer(parseInt(this.gameId.toString()), parseInt(this.questionId.toString()), parseInt(answerId)).subscribe(response => {
        let iAnswerId= answerId.toString();
        this.correctAnswerId = response.correctAnswerId?.toString() ?? "";
        setTimeout(() => {
          if(iAnswerId !== this.correctAnswerId) {
            this.result = "fail";
            this.gameEnded = true;
            return;
          }

          if(response.status.type === "GAMEEND") {
            this.result = "success";
            this.gameEnded = true;
            this.questsHelperService.sendQuestDoneNotification();
            return;
          }

          this.round++;
          this.getQuestion();
        }, 2200);

      });
    }, 500);
  }

  startTimer() {
    this.questionAnsweredLocalState = false;
    this.timeRunning = true;
    this.timePercentage = ((this.timeLeft - 1000) / this.questionDuration) * 100;

    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1000;
        this.timePercentage = ((this.timeLeft - 1000) / this.questionDuration) * 100;
      } else {
        this.stopTimer();
        this.result = "timeout";
        this.gameEnded = true;
      }

      if(this.timeLeft < 10000) {
        this.timeLow = true;
      }

    }, 1000);

  }

  stopTimer() {
    this.timeRunning = false;
    clearInterval(this.timerInterval);
  }

  resetTimer() {
    this.timeRunning = false;
    this.questionAnsweredLocalState = false;
    this.timeLow = false;
    this.timeLeft = this.questionDuration;
    this.timePercentage = 100;
    this.questionText = "";
    this.answers = new Array(0);
  }

  getFormattedTime() {
    const minutes = Math.floor(this.timeLeft / 60000);
    const seconds = ((this.timeLeft % 60000) / 1000).toFixed(0);
    return `${minutes < 10 ? '0' + minutes : minutes}:${parseInt(seconds) < 10 ? '0' : ''}${seconds}`;
  }

  endGame() {
    this.stopTimer();
    this.result = "manually-ended";
    this.gameEnded = true;
  }

  onAnimCreated($event: DotLottie) {
      this.animInterval = window.setInterval(() => {
        if(!$event.isPlaying) {
          $event.stop();
          $event.play();
        }
      }, 6000);
  }

}
